import React from 'react';
import { Timeline, Typography, Tag } from 'antd';
import { EditOutlined, PlusCircleOutlined, ClockCircleOutlined } from '@ant-design/icons';
import moment from 'moment';

const { Text } = Typography;

const AirwayBillHistory = ({ history }) => {
  const getIcon = (action) => {
    switch (action) {
      case '创建':
        return <PlusCircleOutlined style={{ color: '#52c41a' }} />;
      case '修改':
        return <EditOutlined style={{ color: '#1890ff' }} />;
      default:
        return <ClockCircleOutlined style={{ color: '#722ed1' }} />;
    }
  };

  const getActionColor = (action) => {
    switch (action) {
      case '创建':
        return 'success';
      case '修改':
        return 'processing';
      default:
        return 'default';
    }
  };

  return (
    <Timeline>
        {history?.map((record) => (
          <Timeline.Item 
            key={record.id} 
            dot={getIcon(record.action)}
          >
            <div style={{ marginBottom: 4 }}>
              <Tag color={getActionColor(record.action)}>{record.action}</Tag>
              <Text type="secondary" style={{ marginLeft: 8 }}>
                {moment(record.timestamp).format('YYYY-MM-DD HH:mm:ss')}
              </Text>
              <Text style={{ marginLeft: 8 }}>
                操作人: {record.username}
              </Text>
              {record.airway_bill && (
                <Text style={{ marginLeft: 8 }}>
                  空运单号: {record.airway_bill.airway_bill_number}
                </Text>
              )}
            </div>
            <div style={{ 
              background: '#fafafa', 
              padding: '8px', 
              borderRadius: '2px',
              fontSize: '12px',
              whiteSpace: 'pre-wrap'
            }}>
              {record.details}
            </div>
          </Timeline.Item>
        ))}
    </Timeline>
  );
};

export default AirwayBillHistory;
